module.exports = __webpack_public_path__ + "static/img/siege_expert2.c1aeea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/siege_expert2.png
// module id = ++ag
// module chunks = 0